export interface ArchivoRecepcion {
  IdDocumento: string;
  NombreSistema: string;
  NombreOriginal: string;
  Extension: string;
  TamanioKB: number;
  TipoConstancia: number;
  pantalla: number;
  idSolicitud: number;
  order: number;
  FormatoConstancia?: number;
  idCatalogo?: number;
}

export class ArchivoListar {
  IdDocumento!: string;
  NombreSistema!: string;
  NombreSistemaAux!: string;
  NombreOriginal!: string;
  Extension!: string;
  TamanioKB!: number;
  claseIcono!: string;
  claseColor!: string;
  mimeType!: string;
  EstatusDescarga!: boolean;
  idSolicitud!: number;
  FormatoConstancia?: number;
  idCatalogo?: number;
  Guid!:string;   
  iClasificacion?: number;
  isAcuerdoSISE!: boolean;
  extOriginal!:number;
  isLaboral!: boolean;
}

export interface requestDocumentDTO {
  id: number;
  idPantalla: number;
  idDocumento: string;
  estatus: number;
  nombreOriginal: string;
  orden: number;
}

export class Documents {
  id!: string;
  guid!:string;
  idOJ!: number;
  nombreOriginal!: string;  
  nombreSistema!: string;
  estatus!: boolean;
  firmado!: boolean;
  extension!: ExtensionEnum;
  tamanio!: number;
  fecAlta!: string; 
  nombreReal!: string;
  idDocumentoMdw!: number;
  idTransaction!: number;
  iClasificacion?: number;
  isAcuerdoSISE!: boolean;
  extOriginal!:number;
  isLaboral!: boolean;
}

export enum ExtensionEnum
{
     pdf = 1,
     docx = 2,
     doc = 3,
     png = 4,
     jpg = 5
}
